import React from "react";

const SubleagueChatMessages = ({messages}) => {
    if (!messages.length) {
        return null;
    }

    return <table className="zw-table zw-table--dark-striped">
        <tbody>
        {messages.map((message) => <Message key={message.id} {...message}/>)}
        </tbody>
    </table>
};

const Message = ({user, message, sentOn}) =>
    <tr>
        <td className="zw-table__cell-nowrap">
            <i>{sentOn}</i>
        </td>
        <td><strong>{user.nickname}{': '}</strong>{message}</td>
    </tr>;

export default SubleagueChatMessages